import SectionHeading from '@common/SectionHeading';
export default SectionHeading;
